import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { DriversScreen } from '../screens/driver/DriversScreen';
import { DriverDetailsScreen } from '../screens/driver/DriverDetailsScreen';
import { VehicleAssignmentScreen } from '../screens/assignment/VehicleAssignmentScreenNew';
import AddDriverScreen from '../screens/driver/AddDriverScreen';
import { DriverExportScreen } from '../screens/import-export/DriverExportScreen';
import { Ionicons } from '@expo/vector-icons';
import { TouchableOpacity } from 'react-native';
import theme from '../theme';

const Stack = createStackNavigator();

export const DriverNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false, // Disable all headers since we have custom header
      }}
    >
      <Stack.Screen 
        name="Drivers" 
        component={DriversScreen} 
      />
      <Stack.Screen
        name="DriverDetails"
        component={DriverDetailsScreen}
      />
      <Stack.Screen
        name="VehicleAssignment"
        component={VehicleAssignmentScreen}
      />
      <Stack.Screen
        name="AddDriver"
        component={AddDriverScreen}
      />
      <Stack.Screen
        name="DriverExport"
        component={DriverExportScreen}
      />
    </Stack.Navigator>
  );
};
